import Konva from 'konva';
import CustomText from '../CustomText.js';
import { flattenStructuredResponse } from '../PrimitiveConfig.js';
import { guessStructuredSectionStyle } from '../utils/structuredSummary.js';

function toInteger(value, fallback = 0) {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export const categoryColors = [
  '#8dd3c7',
  '#ffffb3',
  '#bebada',
  '#fb8072',
  '#80b1d3',
  '#fdb462',
  '#b3de69',
  '#fccde5',
  '#d9d9d9',
  '#bc80bd',
  '#ccebc5',
  '#ffed6f',
];

export const categoryColors_pastel = [
  '#66c5cc',
  '#f6cf71',
  '#f89c74',
  '#dcb0f2',
  '#87c55f',
  '#9eb9f3',
  '#fe88b1',
  '#c9db74',
  '#8be0a4',
  '#b3b3b3',
];

export const categoryColors2 = [
  '#4e79a7',
  '#f28e2c',
  '#e15759',
  '#76b7b2',
  '#59a14f',
  '#edc949',
  '#af7aa1',
  '#ff9da7',
  '#9c755f',
  '#bab0ab',
];

export const categoryColors_old = [
  '#1F77B4',
  '#FF7F0E',
  '#2CA02C',
  '#D62728',
  '#9467BD',
  '#8C564B',
  '#E377C2',
  '#7F7F7F',
  '#BCBD22',
  '#17BECF',
  '#AEC7E8',
  '#FFBB78',
  '#98DF8A',
  '#FF9896',
  '#C5B0D5',
];

export const categoryColors_MUTED = [
  '#6B8E9E',
  '#D4A76A',
  '#8FBC8F',
  '#C85A5A',
  '#A48ABF',
  '#B07F68',
  '#D6A5C7',
  '#A0A0A0',
  '#C4B76E',
  '#73A2A8',
  '#B0C4DE',
  '#F4C2C2',
  '#BFD8B8',
  '#E6A19F',
  '#D0C4D6',
];

export const categoryColors_STD = [
  '#4E79A7',
  '#F28E2B',
  '#E15759',
  '#76B7B2',
  '#59A14F',
  '#EDC948',
  '#B07AA1',
  '#FF9DA7',
  '#9C755F',
  '#BAB0AC',
  '#86BCB6',
  '#F4A261',
  '#D98880',
  '#A5A58D',
  '#C3C1E3',
];

export const tagColors = {
  Blue: ['#dbeafe', '#bfdbfe', '#93c5fd', '#60a5fa', '#3b82f6', '#2563eb'],
  Green: ['#dcfce7', '#bbf7d0', '#86efac', '#4ade80', '#22c55e', '#16a34a'],
  Yellow: ['#fef9c3', '#fef08a', '#fde047', '#facc15', '#eab308', '#ca8a04'],
  Red: ['#fee2e2', '#fecaca', '#fca5a5', '#f87171', '#ef4444', '#dc2626'],
  Lime: ['#ecfccb', '#d9f99d', '#bef264', '#a3e635', '#84cc16', '#65a30d'],
  Amber: ['#fef3c7', '#fde68a', '#fcd34d', '#fbbf24', '#f59e0b', '#d97706'],
  Indigo: ['#e0e7ff', '#c7d2fe', '#a5b4fc', '#818cf8', '#6366f1', '#4f46e5'],
  Orange: ['#ffedd5', '#fed7aa', '#fdba74', '#fb923c', '#f97316', '#ea580c'],
  Violet: ['#ede9fe', '#ddd6fe', '#c4b5fd', '#a78bfa', '#8b5cf6', '#7c3aed'],
  Cyan: ['#cffafe', '#a5f3fc', '#67e8f9', '#22d3ee', '#06b6d4', '#0891b2'],
  Emerald: ['#d1fae5', '#a7f3d0', '#6ee7b7', '#34d399', '#10b981', '#059669'],
  Teal: ['#ccfbf1', '#99f6e4', '#5eead4', '#2dd4bf', '#14b8a6', '#0d9488'],
  Sky: ['#e0f2fe', '#bae6fd', '#7dd3fc', '#38bdf8', '#0ea5e9', '#0284c7'],
};

export const uflTheme = {
  palette: {
    background: '#ffffff',
    surface: undefined,
    panel: '#f92d64',
    panelText: '#000000',
    header: '#f92d64',
    primary: '#334155',
    secondary: '#9b96a2',
    muted: '#777777',
    accent: '#7e8184',
    headerText: '#222222',
    border: '#f92d64',
    grid: '#f92d64',
    subgrid: '#d2d2d2',
    overlay: '#edf3f8',
    placeholder: '#e2e2e2',
    cell: '#ffffff',
    categoryColors,
    tagColors,
  },
  fontFamily: 'Poppins',
  elements: [
    {
      type: 'image',
      source: 'logo',
      position: 'bottom-right',
      offset: [10, 10],
      size: [80, 80],
    },
    {
      type: 'image',
      source: 'url',
      url: `/api/companyLogo?name=unicornfactorylisboa`,
      position: 'bottom-left',
      offset: [10, 10],
      size: [80, 80],
    },
    {
      type: 'text',
      text: 'Note: This report includes content generated by artificial intelligence (AI). While accuracy is a priority, it is recommended to use this information as a supplement to, rather than a sole basis for, decision-making.',
      align: 'center',
      fontSize: 14,
      color: 'muted',
      position: 'bottom-left',
      top: true,
      offset: [10, 10],
      size: [1900, 14],
    },
  ],
};

export const xploreTheme = {
  palette: {
    background: '#ffffff',
    surface: undefined,
    panel: '#ffdb00',
    header: '#ffdb00',
    primary: '#334155',
    secondary: '#9b96a2',
    muted: '#777777',
    accent: '#7e8184',
    headerText: '#222222',
    border: '#ffdb00',
    grid: '#ffdb00',
    subgrid: '#d2d2d2',
    overlay: '#edf3f8',
    placeholder: '#e2e2e2',
    cell: '#ffffff',
    categoryColors,
    tagColors,
  },
  padding: {
    panel: [20, 8, 20, 8],
  },
  fontFamily: 'Poppins',
  elements: [
    {
      type: 'image',
      source: 'logo',
      position: 'bottom-right',
      offset: [10, 10],
      size: [80, 80],
    },
    {
      type: 'image',
      source: 'url',
      url: `/api/companyLogo?name=ikea`,
      position: 'bottom-left',
      offset: [10, 10],
      size: [80, 80],
    },
    {
      type: 'text',
      text: 'Note: This report includes content generated by artificial intelligence (AI). While accuracy is a priority, it is recommended to use this information as a supplement to, rather than a sole basis for, decision-making.',
      align: 'center',
      fontSize: 14,
      color: 'muted',
      position: 'bottom-left',
      top: true,
      offset: [10, 10],
      size: [1900, 14],
    },
  ],
};

export const darkNavyTheme = {
  palette: {
    background: '#0f172a',
    surface: undefined,
    panel: '#3a4150',
    header: '#212736',
    primary: '#e6eaee',
    secondary: '#cbd5e1',
    muted: '#a6aaae',
    accent: '#38bdf8',
    headerText: '#C3CCD5',
    border: 'none',
    grid: '#cbd5e1',
    subgrid: '#334155',
    overlay: '#1e293b',
    placeholder: '#475569',
    hoverFill: '#00B0F025',
    hoverStroke: '#00B0F088',
    cell: '#333A47',
    categoryColors,
    tagColors,
  },
  fontFamily: 'Poppins',
  elements: [
    {
      type: 'image',
      source: 'workspace',
      position: 'top-right',
      offset: [10, 10],
      size: [80, 80],
    },
    {
      type: 'text',
      text: 'Note: This report includes content generated by artificial intelligence (AI). While accuracy is a priority, it is recommended to use this information as a supplement to, rather than a sole basis for, decision-making.',
      align: 'center',
      fontSize: 14,
      color: 'muted',
      position: 'bottom-left',
      top: true,
      offset: [10, 10],
      size: [1900, 14],
    },
  ],
};

export const defaultTheme = {
  palette: {
    background: '#fcfcfc',
    surface: undefined,
    panel: '#f2f2f2',
    header: '#f2f2f2',
    primary: '#334155',
    secondary: '#9b96a2',
    muted: '#777777',
    accent: '#7e8184',
    headerText: '#334155',
    border: '#e2e2e2',
    grid: '#e2e2e2',
    subgrid: '#d2d2d2',
    overlay: '#edf3f8',
    placeholder: '#e2e2e2',
    cell: '#ffffff',
    danger: '#f97316',
    categoryColors,
    tagColors,
  },
  fontFamily: 'Poppins',
  padding: {
    panel: [20, 8, 20, 8],
  },
  elements: [
    {
      type: 'image',
      source: 'logo',
      position: 'bottom-right',
      offset: [10, 10],
      size: [80, 80],
    },
    {
      type: 'text',
      text: 'Note: This report includes content generated by artificial intelligence (AI). While accuracy is a priority, it is recommended to use this information as a supplement to, rather than a sole basis for, decision-making.',
      align: 'center',
      fontSize: 14,
      color: 'muted',
      position: 'bottom-left',
      top: true,
      offset: [10, 10],
      size: [1900, 14],
    },
  ],
};

export const themes = {
  default: defaultTheme,
  darkNavy: darkNavyTheme,
  xplore: xploreTheme,
  ufl: uflTheme,
};

export function themeColor(theme, key, fallback, override) {
  if (override) {
    if (override.startsWith('#')) {
      return override;
    }
    return theme?.palette?.[override] ?? fallback;
  }
  return theme?.palette?.[key] ?? fallback;
}

export function mixHexWithWhite(hex, opacity = 0.25) {
  return mixHex(hex, '#ffffff', opacity);
}

export function mixHex(hex, hex2, opacity = 0.25) {
  if (!hex || !hex2) {
    return hex;
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  const r2 = parseInt(hex2.slice(1, 3), 16);
  const g2 = parseInt(hex2.slice(3, 5), 16);
  const b2 = parseInt(hex2.slice(5, 7), 16);

  const newR = Math.round((1 - opacity) * r + opacity * r2);
  const newG = Math.round((1 - opacity) * g + opacity * g2);
  const newB = Math.round((1 - opacity) * b + opacity * b2);

  const toHex = (value) => value.toString(16).padStart(2, '0');
  return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
}

const normalizeHeading = (heading = "") => heading.toLowerCase().trim();
const COMPANY_LOGO_KEYWORD_RE = /(logo|logo wall|logo grid|brand mark|brand logo|badge wall|badge list)/;
const COMPANY_LOGO_MATCH_TARGETS = [
  'company logos',
  'logo wall',
  'logo grid',
  'logos',
  'partner logos',
  'brand logos',
  'brand marks',
  'badge wall',
];

const looksLikeCompanyLogoHeading = (heading) => {
  const normalized = normalizeHeading(heading);
  if (!normalized) return false;
  return COMPANY_LOGO_KEYWORD_RE.test(normalized);
};

const defaultCompareHeadings = (a = "", b = "") => {
  if (!a || !b) return 0;
  if (a === b) return 1;
  if (a.includes(b) || b.includes(a)) return 0.85;
  return 0;
};

function makeScoreMatch(compareFn = defaultCompareHeadings) {
  return (heading, targets = []) => {
    const h = normalizeHeading(heading);
    if (!h) return 0;
    let best = 0;
    for (const target of targets.flat()) {
      const t = normalizeHeading(target);
      if (!t) continue;
      if (h === t) return 1;
      if (h.includes(t) || t.includes(h)) {
        best = Math.max(best, 0.85);
      }
      best = Math.max(best, compareFn(h, t));
    }
    return best;
  };
}

const buildHeightResult = (height = 0, ctx, { includeSpacing = true } = {}) => {
  const baseHeight = Math.max(0, Number.isFinite(height) ? height : 0);
  const spacing = includeSpacing ? Math.max(0, ctx?.spaceY ?? 0) : 0;
  return {
    heightConsumed: baseHeight,
    heightWithPaddingConsumed: baseHeight + spacing,
  };
};

const mergeConfigIntoNode = (sourceNode, config = {}) => {
  if (!sourceNode || typeof sourceNode !== 'object') {
    return sourceNode;
  }
  const merged = { ...sourceNode };
  if (config.itemCount !== undefined && merged.itemCount === undefined) {
    merged.itemCount = config.itemCount;
  }
  if (config.includeIcons !== undefined && merged.includeIcons === undefined) {
    merged.includeIcons = config.includeIcons;
  }
  return merged;
};

function applyPlainTransform(def, style, section, options) {
  if (def && typeof def.transformPlain === 'function') {
    return def.transformPlain(section, options);
  }
  switch (style) {
    case 'detailsBullets':
      return transformDetailsBullets(section);
    case 'quotes':
      return transformQuotes(section);
    case 'segmentTitle': {
      const baseFontSize = options?.baseFontSize ?? 16;
      return {
        ...section,
        fontSize: section.fontSize ?? baseFontSize * 1.2,
        fontStyle: section.fontStyle ?? 'bold',
        sectionStart: true,
      };
    }
    case 'title': {
      const baseFontSize = options?.baseFontSize ?? 16;
      return {
        ...section,
        fontSize: section.fontSize ?? baseFontSize * 1.5,
        fontStyle: section.fontStyle ?? 'bold',
      };
    }
    case 'summary': {
      const baseFontSize = options?.baseFontSize ?? 16;
      return {
        ...section,
        fontSize: section.fontSize ?? baseFontSize * 1.2,
      };
    }
    case 'sentiment':
      return transformSentiment(section);
    case 'company_logos':
    case 'organizations':
      return transformCompanyList(section);
    default:
      return section ? { ...section } : section;
  }
}

export function getStructuredSummaryRenderers(deps = {}) {
  const {
    mkText,
    theme,
    themeColor: themeColorFn,
    resolvedFontColor,
    placeholderFill,
    tableHeaderBackground,
    tableHeaderFontColor,
    tableHeaderPlaceholderFill,
    compareFn,
    imageHelper: imageHelperFn,
    resolvePrimitiveForHeader: resolvePrimitiveForHeaderFn,
    resolvePrimitiveImageUrl: resolvePrimitiveImageUrlFn,
  } = deps;

  const scoreMatch = makeScoreMatch(compareFn);

  const mkRendererText = (attrs) => (mkText ? mkText(attrs) : null);

  return [
    {
      name: 'segmentTitle',
      match: (heading, node, ctx = {}) => {
        if (!ctx?.primitive?.filterDescription) return 0;
        if (ctx?.options?.data?.segment_title) return 0.98;
        return 0;
      },
      render: mkText
        ? (ctx, node) => {
            const text = `**${ctx.primitive.filterDescription}**`;
            const t = mkRendererText({
              x: ctx.x,
              y: ctx.y,
              fontSize: ctx.config.fontSize * 1.5,
              fontStyle: ctx.config.fontStyle,
              lineHeight: 1.1,
              text,
              width: ctx.availableWidth,
            });
            ctx.group.add(t);
            return buildHeightResult(t.height(), ctx);
          }
        : undefined,
      transformPlain: (section, options = {}) => {
        const baseFontSize = options.baseFontSize ?? 16;
        return {
          ...section,
          fontSize: section.fontSize ?? baseFontSize * 1.2,
          fontStyle: section.fontStyle ?? 'bold',
          sectionStart: true,
        };
      },
    },
    {
      name: 'title',
      match: (heading) => scoreMatch(heading, ['title', 'analysis title', 'summary title']),
      render: mkText
        ? (ctx, node) => {
            const titleText = (node.content || node.heading || '').split("\n")[0].replace(/^title\s*[-:]\s*/i, '').replace(/^#\s+/,'')
            const t = mkRendererText({
              x: ctx.x,
              y: ctx.y,
              fontSize: ctx.config.fontSize * 1.5,
              fontStyle: ctx.config.fontStyle,
              lineHeight: 1.3,
              text: `**${titleText}**`,
              width: ctx.availableWidth,
              name: 'section section_title',
            });
            ctx.group.add(t);
            return buildHeightResult(t.height(), ctx);
          }
        : undefined,
      transformPlain: (section, options = {}) => {
        const baseFontSize = options.baseFontSize ?? 16;
        return {
          ...section,
          fontSize: section.fontSize ?? baseFontSize * 1.5,
          fontStyle: section.fontStyle ?? 'bold',
        };
      },
    },
    {
      name: 'summary',
      match: (heading) => scoreMatch(heading, ['description', 'summary', 'overview']),
      render: mkText
        ? (ctx, node) => {
            const sectionGroup = new Konva.Group({
              x: ctx.x,
              y: ctx.y,
              name: 'section section_summary',
            });
            ctx.group.add(sectionGroup);
            const headingText = typeof node.heading === 'string' ? node.heading.trim() : '';
            let cursorY = 0;
            if (ctx.config.heading !== false && headingText) {
              const headingNode = mkRendererText({
                x: 0,
                y: 0,
                fontSize: Math.max(12, ctx.config.fontSize * 1.15),
                fontStyle: 'bold',
                text: headingText.toUpperCase(),
                width: ctx.availableWidth,
                withMarkdown: false,
                fill: themeColorFn ? themeColorFn(theme, 'muted', '#6b7280') : resolvedFontColor,
                name: 'section section_summary_heading',
              });
              sectionGroup.add(headingNode);
              cursorY += headingNode.height() + ctx.spaceY * 0.35;
            }
            const bodyNode = mkRendererText({
              x: 0,
              y: cursorY,
              fontSize: ctx.config.fontSize * 1.2,
              fontStyle: ctx.config.fontStyle,
              text: node.content ?? '',
              width: ctx.availableWidth,
              name: 'section section_summary_body',
            });
            sectionGroup.add(bodyNode);
            return buildHeightResult(cursorY + bodyNode.height(), ctx);
          }
        : undefined,
      transformPlain: (section, options = {}) => {
        const baseFontSize = options.baseFontSize ?? 16;
        return {
          ...section,
          fontSize: section.fontSize ?? baseFontSize * 1.2,
        };
      },
    },
    {
      name: 'detailsBullets',
      match: (heading) => scoreMatch(heading, ['recurring topics', 'themes', 'topics', 'capabilities']),
      render: mkText
        ? (ctx, node) => {
            const sectionGroup = new Konva.Group({
              x: ctx.x,
              y: ctx.y,
              name: 'section section_details',
            });
            ctx.group.add(sectionGroup);
            const headingText = typeof node.heading === 'string' ? node.heading.trim() : '';
            const showHeading = ctx.config.heading !== false;
            let cursorY = 0;
            if (showHeading && headingText) {
              const headingNode = mkRendererText({
                x: 0,
                y: 0,
                fontSize: Math.max(12, ctx.config.fontSize * 1.2),
                fontStyle: 'bold',
                text: headingText.toUpperCase(),
                width: ctx.availableWidth,
                withMarkdown: false,
                fill: themeColorFn ? themeColorFn(theme, 'muted', '#6b7280') : resolvedFontColor,
                name: 'section section_details_heading',
              });
              if (headingNode) {
                sectionGroup.add(headingNode);
                cursorY += headingNode.height() + ctx.spaceY * 0.35;
              }
            }
            let contentEntries;
            if (typeof node.content === 'string') {
              contentEntries = node.content.split(/\n/);
            } else if (Array.isArray(node.content)) {
              contentEntries = node.content;
            } else {
              contentEntries = node.subsections?.map((d) => d.content);
            }
            contentEntries = (contentEntries || []);
            if (ctx.config.itemCount !== undefined) {
              contentEntries = contentEntries.slice(0, ctx.config.itemCount);
            }
            const lines = contentEntries
              .filter((d) => typeof d === 'string')
              .map((d) =>
                d.replace(/^([\s*-?]*)([^:]+)([:\]])/, (match, prefix, label, delimiter) => {
                  let inner = label;
                  let leadingMarkers = '';
                  let trailingMarkers = '';
                  const leadingMatch = inner.match(/^[_*`~]+/);
                  if (leadingMatch) {
                    leadingMarkers = leadingMatch[0];
                    inner = inner.slice(leadingMarkers.length);
                  }
                  const trailingMatch = inner.match(/[_*`~]+$/);
                  if (trailingMatch) {
                    trailingMarkers = trailingMatch[0];
                    inner = inner.slice(0, -trailingMarkers.length);
                  }
                  inner = inner.trim();
                  if (inner.startsWith('[')) inner = inner.slice(1);
                  if (inner.endsWith(']')) inner = inner.slice(0, -1);
                  const alreadyStyled =
                    (/^[_*`]/.test(inner) && /[_*`]+$/.test(inner)) ||
                    Boolean(leadingMarkers || trailingMarkers);
                  if (!alreadyStyled) {
                    if (!inner.startsWith('**')) inner = `**${inner}`;
                    if (!inner.endsWith('**')) inner = `${inner}**`;
                  }
                  return `${leadingMarkers}${inner}${trailingMarkers}${delimiter ?? ''}`;
                })
              )
              .map((line) => ensureBulletPrefix(line))
              .filter((line) => typeof line === 'string' && line.trim().length > 0);

            if (!lines.length) {
              return buildHeightResult(cursorY, ctx, { includeSpacing: false });
            }

            const content = lines.join('\n');
            const color = themeColorFn ? themeColorFn(theme, 'secondary') : resolvedFontColor;
            const canRenderIcons =
              Boolean(ctx.config.includeIcons) &&
              Boolean(imageHelperFn) &&
              typeof resolvePrimitiveForHeaderFn === 'function' &&
              typeof resolvePrimitiveImageUrlFn === 'function';

            if (!canRenderIcons) {
              const t = mkRendererText({
                x: 0,
                y: cursorY,
                fontSize: ctx.config.fontSize,
                fontStyle: ctx.config.fontStyle,
                text: content,
                width: ctx.availableWidth,
                fill: color,
                name: 'section section_details',
              });
              sectionGroup.add(t);
              return buildHeightResult(cursorY + t.height(), ctx);
            }

            const indent = BULLET_ICON_INDENT;
            const fontSize = ctx.config.fontSize ?? 16;
            const iconSize = Math.max(Math.min(indent - 6, fontSize * 2.5), 14);
            let consumed = cursorY;

            for (const rawLine of lines) {
              const textLine = rawLine.trim();
              if (!textLine) continue;
              const displayLine = stripBulletMarkerForIcon(textLine);
              const lineY = consumed;
              const textNode = mkRendererText({
                x: indent,
                y: lineY,
                fontSize,
                fontStyle: ctx.config.fontStyle,
                text: displayLine,
                width: Math.max(ctx.availableWidth - indent, 0),
                fill: color,
                name: 'section section_details bullet_text',
              });
              sectionGroup.add(textNode);

              const textHeight = textNode.height();
              const match = findPrimitiveMatchForBullet(displayLine, resolvePrimitiveForHeaderFn);
              const iconY = lineY;
              const iconX = Math.max((indent - iconSize) / 2, 0);
              let iconNode;

              if (match) {
                const iconUrl = resolvePrimitiveImageUrlFn(match.primitive, match.phrase);
                if (iconUrl) {
                  iconNode = imageHelperFn(iconUrl, {
                    x: iconX,
                    y: iconY,
                    width: iconSize,
                    height: iconSize,
                    imageCallback: ctx.options.imageCallback,
                    placeholder: ctx.options.placeholder !== false,
                    name: 'section section_details_icon',
                  });
                }
              }

              if (!iconNode) {
                iconNode = createBulletIconPlaceholder({
                  x: iconX,
                  y: iconY,
                  size: iconSize,
                  fill: ctx.options.placeholderFill,
                });
              }

              if (iconNode) {
                sectionGroup.add(iconNode);
              }

              consumed += Math.max(textHeight, iconSize) + ctx.spaceY * 0.5;
            }

            const totalHeight = consumed + ctx.spaceY * 0.5;
            return buildHeightResult(totalHeight, ctx);
          }
        : undefined,
      transformPlain: (section) => transformDetailsBullets(section),
    },
    {
      name: 'quotes',
      match: (heading) => scoreMatch(heading, ['quotes', 'verbatim quotes', 'examples', 'evidence quotes', 'customers']),
      render: mkText
        ? (ctx, node) => {
            const sectionGroup = new Konva.Group({
              x: ctx.x + ctx.config.padding[3] * 2,
              y: ctx.y,
              name: 'section section_quotes',
            });
            ctx.group.add(sectionGroup);
            const headingText = typeof node.heading === 'string' ? node.heading.trim() : '';
            let cursorY = 0;
            if (ctx.config.heading !== false && headingText) {
              const headingNode = mkRendererText({
                x: 0,
                y: 0,
                fontSize: Math.max(12, ctx.config.fontSize * 1.1),
                fontStyle: 'bold',
                text: headingText.toUpperCase(),
                width: ctx.availableWidth - ctx.config.padding[3] * 4 - ctx.config.padding[1],
                withMarkdown: false,
                fill: themeColorFn ? themeColorFn(theme, 'muted', '#6b7280') : resolvedFontColor,
                name: 'section section_quotes_heading',
              });
              sectionGroup.add(headingNode);
              cursorY += headingNode.height() + ctx.spaceY * 0.35;
            }
            let content;
            if (typeof node.content === 'string') content = node.content;
            else if (Array.isArray(node.content)) content = node.content.join('\n');
            else content = node.subsections?.map((d) => d.content).join('\n');

            const regex = /\(?[Ff]ragments?:? ?(?:\d+(?:, ?\d+)*|\d+(?: and \d+)*|\d+)\)?/g;
            const lines = (content || '')
              .replace(regex, '')
              .replace(/[ \t]{2,}/g, ' ')
              .trim()
              .split('\n')
              .map((line) => {
                const match = line.match(/^(\s*(?:[-*]|\d+\.)?\s*)(.*)$/);
                const text = match ? match[2] : line;
                const trimmed = (text || '').trim();
                if (!trimmed) return '';
                const hasQuote = /["“”]/.test(trimmed);
                const normalized = (hasQuote ? trimmed : `"${trimmed}"`).replaceAll('""', '"');
                return wrapQuotedSectionsWithItalics(normalized);
              })
              .filter(Boolean);

            const limitedLines =
              ctx.config.itemCount !== undefined ? lines.slice(0, ctx.config.itemCount) : lines;
            const normalizedContent = limitedLines.join('\n');

            const t = mkRendererText({
              x: 0,
              y: cursorY,
              fontSize: ctx.config.fontSize,
              fontStyle: ctx.config.fontStyle ?? 'normal',
              lineHeight: 1.1,
              sectionSpacing: 2.2,
              fill: resolvedFontColor,
              text: normalizedContent,
              width: ctx.availableWidth - ctx.config.padding[3] * 4 - ctx.config.padding[1],
              name: 'section section_quotes_body',
            });
            sectionGroup.add(t);
            const result = buildHeightResult(cursorY + t.height(), ctx);
            if (Array.isArray(node?.subsections) && node.subsections.length > 0) {
              result.skipTraversal = true;
            }
            return result;
          }
        : undefined,
      transformPlain: (section) => transformQuotes(section),
    },
    {
      name: 'sentiment',
      match: (heading) => scoreMatch(heading, ['overall sentiment', 'sentiment']),
      render: mkText
        ? (ctx, node) => {
            const g2 = new Konva.Group({
              x: ctx.x,
              y: ctx.y,
              name: 'section section_sentiment',
            });
            ctx.group.add(g2);
            let ly = 0;
            const headingValue = typeof node.heading === 'string' ? node.heading.trim() : '';
            if (ctx.config.heading !== false && headingValue) {
              const headingNode = mkRendererText({
                x: 0,
                y: 0,
                fontSize: Math.max(12, ctx.config.fontSize * 1.05),
                fontStyle: 'bold',
                text: headingValue.toUpperCase(),
                width: ctx.availableWidth,
                withMarkdown: false,
                fill: themeColorFn ? themeColorFn(theme, 'muted', '#6b7280') : resolvedFontColor,
                name: 'section section_sentiment_heading',
              });
              g2.add(headingNode);
              ly += headingNode.height() + ctx.spaceY * 0.35;
            }

            const headingText = mkRendererText({
              x: 0,
              y: 0,
              fontSize: ctx.config.fontSize,
              text: 'Sentiment',
              width: ctx.availableWidth,
            });
            g2.add(headingText);
            ly += headingText.height() + ctx.spaceY / 2;

            const steps = ['overwhelmingly negative', 'mostly negative', ['neutral', 'mixed'], 'mostly positive', 'overwhelmingly positive'];
            const stepText = ['Overwhelmingly Negative', 'Mostly Negative', 'Neutral / Mixed', 'Mostly Positive', 'Overwhelmingly Positive'];
            const colors = ['#eeb9b7', '#f8d1a0', '#bcddfb', '#a2ccfb', '#cbe6bc'];
            const sentimentText = node.content;
            const score = steps.findIndex((d) => (typeof d === 'string' ? d === sentimentText : d.includes(sentimentText)));
            const stepWidth = ctx.availableWidth / steps.length;
            const h = ctx.config.fontSize * 1.25;

            steps.forEach((d, i) => {
              g2.add(
                new Konva.Rect({
                  x: stepWidth * i,
                  y: ly,
                  width: stepWidth,
                  height: h,
                  stroke: '#c2c2c2',
                  fill: colors[i],
                })
              );
            });
            ly += h + (score > -1 ? ctx.spaceY : ctx.spaceY * 0.5);

            const label = mkRendererText({
              x: 0,
              y: ly,
              fontSize: ctx.config.fontSize,
              text: score === -1 ? sentimentText || '' : stepText[score],
              width: 'auto',
              align: 'center',
            });
            if (score > -1) {
              const midX = (score + 0.5) * stepWidth;
              g2.add(label);
              label.x(midX - label.width() / 2);
              g2.add(
                new Konva.Line({
                  x: midX,
                  y: ly - ctx.config.fontSize * 1.5,
                  points: [0, 0, ctx.config.fontSize / 2, ctx.config.fontSize, -ctx.config.fontSize / 2, ctx.config.fontSize],
                  closed: true,
                  strokeWidth: 0,
                  fill: '#666',
                })
              );
            } else {
              g2.add(label);
            }

            ly += label.height() + ctx.spaceY / 2;
            return buildHeightResult(ly, ctx);
          }
        : undefined,
      transformPlain: (section) => transformSentiment(section),
    },
    {
      name: 'company_logos',
      match: (heading) => {
        if (!looksLikeCompanyLogoHeading(heading)) {
          return 0;
        }
        return scoreMatch(heading, COMPANY_LOGO_MATCH_TARGETS);
      },
      render: mkText && imageHelperFn
        ? (ctx, node) => {
            const names = Array.isArray(node.content)
              ? node.content
              : String(node.content || '')
                  .split(/,|\n|\sand\s|\swith\s/)
                  .map((d) => d.replace(/^\s*-\s+/, '').trim())
                  .filter(Boolean);

            const companySizing = 96;
            let x = ctx.config.padding[3];
            const spaceX = ctx.spaceY / 2;
            let consumed = 0;
            const itemHeight = 48 + ctx.spaceY * 0.5 + ctx.config.fontSize * 0.6 + ctx.spaceY;
            const headingText = typeof node.heading === 'string' ? node.heading.trim() : '';
            if (ctx.config.heading !== false && headingText) {
              const headingNode = mkRendererText({
                x: ctx.x,
                y: ctx.y,
                fontSize: Math.max(12, ctx.config.fontSize * 1.1),
                fontStyle: 'bold',
                text: headingText.toUpperCase(),
                width: ctx.availableWidth,
                withMarkdown: false,
                fill: themeColorFn ? themeColorFn(theme, 'muted', '#6b7280') : resolvedFontColor,
                name: 'section section_company_logos_heading',
              });
              ctx.group.add(headingNode);
              consumed += headingNode.height() + ctx.spaceY * 0.5;
            }
            let idx = -1;
            for (const d of names) {
              idx++;
              if (ctx.config.itemCount > 0 && idx >= ctx.config.itemCount) {
                break;
              }
              if (x + companySizing + spaceX > ctx.availableWidth) {
                x = ctx.config.padding[3];
                consumed += itemHeight;
              }
              const logo = imageHelperFn(`/api/companyLogo?name=${d}`, {
                x,
                y: ctx.y + consumed,
                width: companySizing,
                height: companySizing / 2,
                center: true,
                imageCallback: ctx.options.imageCallback,
                placeholder: ctx.options.placeholder !== false,
                maxScale: 1,
                scaleRatio: 1,
              });
              ctx.group.add(logo);
              const t = mkRendererText({
                x,
                y: ctx.y + consumed + companySizing / 2 + ctx.spaceY * 0.5,
                fontSize: ctx.config.fontSize * 0.6,
                text: d,
                align: 'center',
                width: companySizing,
              });
              ctx.group.add(t);
              x += companySizing + spaceX;
            }
            consumed += itemHeight + ctx.config.padding[2] + ctx.spaceY;
            return buildHeightResult(consumed, ctx);
          }
        : undefined,
      transformPlain: (section) => transformCompanyList(section),
    },
    {
      name: 'organizations',
      match: () => 0,
      render: mkText && imageHelperFn
        ? (ctx, node) => {
            const names = Array.isArray(node.content)
              ? node.content
              : String(node.content || '')
                  .split(/,|\n|\sand\s|\swith\s/)
                  .map((d) => d.replace(/^\s*-\s+/, '').trim())
                  .filter(Boolean);

            const candidates = ctx.options?.data?.company_candidates ?? [];
            const companySizing = 96;
            let x = ctx.config.padding[3];
            let consumed = ctx.spaceY * 2;

            const headingText = typeof node.heading === 'string' ? node.heading.trim() : '';
            if (ctx.config.heading !== false && headingText) {
              const headingNode = mkRendererText({
                x: ctx.x,
                y: ctx.y,
                fontSize: Math.max(12, ctx.config.fontSize * 1.1),
                fontStyle: 'bold',
                text: headingText.toUpperCase(),
                width: ctx.availableWidth,
                withMarkdown: false,
                fill: themeColorFn ? themeColorFn(theme, 'muted', '#6b7280') : resolvedFontColor,
                name: 'section section_organizations_heading',
              });
              ctx.group.add(headingNode);
              consumed += headingNode.height() + ctx.spaceY * 0.5;
            }

            const pickPrimitive = (name) => {
              const variants = name
                .split(' ')
                .map((_, i, arr) => arr.slice(0, i + 1).join(' '))
                .reverse();
              for (const v of variants) {
                let p = candidates.find((d) => d.title.toLowerCase() === v.toLowerCase());
                if (!p && compareFn) {
                  const scored = candidates
                    .map((d) => [d, compareFn(d.title, v)])
                    .filter((d) => d[1] > 0.75)
                    .sort((a, b) => b[1] - a[1]);
                  p = scored[0]?.[0];
                }
                if (p) return p;
              }
              return undefined;
            };

            const primitives = names.map(pickPrimitive).filter(Boolean).slice(0, 5);

            for (const d of primitives) {
              const logo = imageHelperFn(`/api/image/${d.id}` + (d.imageCount ? `?${d.imageCount}` : ''), {
                x,
                y: ctx.y + consumed,
                width: companySizing,
                height: companySizing / 2,
                center: true,
                imageCallback: ctx.options.imageCallback,
                placeholder: ctx.options.placeholder !== false,
                maxScale: 1,
                scaleRatio: 1,
              });
              ctx.group.add(logo);
              const t = mkRendererText({
                x,
                y: ctx.y + consumed + companySizing / 2 + ctx.spaceY,
                fontSize: ctx.config.fontSize * 0.6,
                text: d.title,
                align: 'center',
                width: companySizing,
              });
              ctx.group.add(t);
              x += companySizing + ctx.config.padding[3];
            }
            const height = 48 + ctx.spaceY + ctx.config.fontSize * 0.6 + ctx.spaceY * 3;
            return buildHeightResult(height, ctx);
          }
        : undefined,
      transformPlain: (section) => transformCompanyList(section),
    },
    {
      name: 'paragraphFallback',
      match: (heading, node) => {
        const has = node?.content && String(node.content).trim() ? 0.65 : 0;
        return has;
      },
      render: mkText
        ? (ctx, node) => {
            const sectionGroup = new Konva.Group({
              x: ctx.x,
              y: ctx.y,
              name: 'section section_paragraph',
            });
            ctx.group.add(sectionGroup);

            const headingText = typeof node.heading === 'string' ? node.heading.trim() : '';
            let cursorY = 0;
            if (ctx.config.heading !== false && headingText) {
              const headingNode = mkRendererText({
                x: 0,
                y: 0,
                fontSize: Math.max(12, ctx.config.fontSize * 1.15),
                fontStyle: 'bold',
                text: headingText.toUpperCase(),
                width: ctx.availableWidth,
                withMarkdown: false,
                fill: themeColorFn ? themeColorFn(theme, 'muted', '#6b7280') : resolvedFontColor,
                name: 'section section_paragraph_heading',
              });
              if (headingNode) {
                sectionGroup.add(headingNode);
                cursorY += headingNode.height() + ctx.spaceY * 0.35;
              }
            }

            const bodyNode = mkRendererText({
              x: 0,
              y: cursorY,
              fontSize: ctx.config.fontSize,
              fontStyle: ctx.config.fontStyle ?? 'light',
              text: node?.content ? String(node.content) : node?.heading || '',
              width: ctx.availableWidth,
              name: 'section section_paragraph_body',
            });
            if (bodyNode) {
              bodyNode.attrs.refreshCallback = ctx.options.imageCallback;
              sectionGroup.add(bodyNode);
              const totalHeight = cursorY + bodyNode.height();
              return buildHeightResult(totalHeight, ctx);
            }
            return buildHeightResult(cursorY, ctx, { includeSpacing: false });
          }
        : undefined,
      transformPlain: (section, options = {}) => {
        const baseFontSize = options.baseFontSize ?? 16;
        return {
          ...section,
          fontSize: section.fontSize ?? baseFontSize,
          fontStyle: section.fontStyle ?? 'light',
        };
      },
    },
  ];
}

const baseStructuredSummaryRenderers = getStructuredSummaryRenderers();
const structuredSummaryRenderersByName = Object.fromEntries(
  baseStructuredSummaryRenderers.map((def) => [def.name, def])
);

export function formatSectionForPlainText(section, { baseFontSize = 16, compareFn } = {}) {
  if (!section || typeof section !== 'object') {
    return section;
  }

  const detectedStyle =
    section.sectionStyle ??
    section.autoSectionStyle ??
    guessStructuredSectionStyle(section, { compareFn });

  if (!detectedStyle) {
    return { ...section };
  }

  const def = structuredSummaryRenderersByName[detectedStyle];
  if (!def) {
    return applyPlainTransform(undefined, detectedStyle, { ...section }, { baseFontSize, compareFn });
  }

  const output = {
    ...section,
    autoSectionStyle: section.autoSectionStyle ?? detectedStyle,
  };

  return applyPlainTransform(def, detectedStyle, output, { baseFontSize, compareFn });
}

export function renderFormattedSections(text, group, fullOptions = {}) {
  const { width, height, fontFamily, ...options } = fullOptions;
  let didOverflow = false;
  const padding = options.padding ?? [0, 0, 0, 0];
  const [padTop, padRight, padBottom, padLeft] = padding;
  const maxContentHeight =
    typeof height === 'number' ? Math.max(0, height - padTop - padBottom) : undefined;
  group.name('inf_track primitive');
  const sectionConfigMap =
    options.sectionConfig && typeof options.sectionConfig === 'object' ? options.sectionConfig : undefined;
  const wantsVerticalSections =
    !options.disableVerticalSections && Boolean(sectionConfigMap?.vertical_sections);
  let workingText = Array.isArray(text) ? text : [];
  let autoColumns;
  if (wantsVerticalSections) {
    const blockLengths = workingText.map((block) => (Array.isArray(block) ? block.length : 0));
    autoColumns = Math.max(blockLengths.length ? Math.max(...blockLengths) : 0, 1);
    workingText = workingText.flatMap((block) =>
      Array.isArray(block) ? block.map((section) => [section]) : []
    );
  }
  const columns = options.columns ?? autoColumns ?? 1;
  if (columns > 1 && !wantsVerticalSections && options.alternateColumns !== false) {
    workingText = workingText.flatMap((block) =>
      Array.isArray(block) ? block.map((section) => [section]) : []
    );
  }
  const alignRows = options.alignRows ?? Boolean(autoColumns);
  const baseFontSize = options.fontSize ?? 16;
  const baseLineHeight = options.lineHeight ?? 1.2;
  const basePaddingBetweenColumns = baseFontSize * 0.5;
  const columnSpacing =
    options.columnSpacing ??
    (wantsVerticalSections ? Math.max((width - padLeft - padRight) * 0.05, basePaddingBetweenColumns) : basePaddingBetweenColumns);
  const textWidth = (width - padLeft - padRight - columnSpacing * (columns - 1)) / columns;
  let columnIndex = 0;
  const columnPositions = new Array(columns).fill(0);

  const computeSectionSpacing = (section = {}) => {
    const fontSize = section.fontSize ?? baseFontSize;
    const startMultiplier = section.sectionStart ? 0.5 : 1;
    const spacingMultiplier = section.largeSpacing ? 1.5 : 0.5;
    return fontSize * baseLineHeight * startMultiplier * spacingMultiplier;
  };

  const baseRendererConfig = {
    fontSize: baseFontSize,
    fontStyle: options.fontStyle,
    padding,
    itemCount: options.itemCount,
    includeIcons: options.includeIcons ?? false,
  };

  const mkRendererText = (attrs = {}) =>
    new CustomText({
      fontFamily: attrs.fontFamily ?? fontFamily,
      fill: attrs.fill ?? options.fontFill,
      placeholderFill: attrs.placeholderFill ?? options.placeholderFill,
      tableHeaderFill: attrs.tableHeaderFill ?? options.tableHeaderFill,
      tableHeaderColor: attrs.tableHeaderColor ?? options.tableHeaderColor,
      tableHeaderPlaceholderFill: attrs.tableHeaderPlaceholderFill ?? options.tableHeaderPlaceholderFill,
      lineHeight: attrs.lineHeight ?? baseLineHeight,
      withMarkdown: attrs.withMarkdown ?? true,
      refreshCallback: attrs.refreshCallback ?? options.imageCallback,
      ...attrs,
    });

  const rendererDefs = getStructuredSummaryRenderers({
    mkText: mkRendererText,
    theme: options.theme,
    themeColor: options.themeColor,
    resolvedFontColor: options.fontFill,
    placeholderFill: options.placeholderFill,
    tableHeaderBackground: options.tableHeaderFill,
    tableHeaderFontColor: options.tableHeaderColor,
    tableHeaderPlaceholderFill: options.tableHeaderPlaceholderFill,
    compareFn: options.compareFn,
    imageHelper: options.imageHelper,
    resolvePrimitiveForHeader: options.resolvePrimitiveForHeader,
    resolvePrimitiveImageUrl: options.resolvePrimitiveImageUrl,
  });
  const rendererEntries = rendererDefs.filter((def) => typeof def.render === 'function');
  const rendererMap = Object.fromEntries(rendererEntries.map((def) => [def.name, def]));
  const matchCtx = { primitive: options.primitive, options };

  const detectStyle = (section) =>
    section?.sectionStyle ??
    section?.autoSectionStyle ??
    guessStructuredSectionStyle(section, { compareFn: options.compareFn });

  const pickRenderer = (section) => {
    if (!section || typeof section !== 'object') {
      return { renderer: undefined, node: section };
    }
    const detectedStyle = detectStyle(section);
    if (detectedStyle && rendererMap[detectedStyle]) {
      const withStyle =
        section.autoSectionStyle || !detectedStyle
          ? section
          : { ...section, autoSectionStyle: section.autoSectionStyle ?? detectedStyle };
      return { renderer: rendererMap[detectedStyle], node: withStyle };
    }
    let best = { score: -Infinity, renderer: undefined };
    for (const candidate of rendererEntries) {
      if (typeof candidate.match !== 'function') continue;
      const heading = section.heading ?? section.originalHeading ?? '';
      const score = candidate.match(heading, section, matchCtx) ?? 0;
      if (score > best.score) {
        best = { score, renderer: candidate };
      }
    }
    return { renderer: best.renderer, node: section };
  };

  const resolveHeadingPreference = (section) => {
    if (!sectionConfigMap) {
      return undefined;
    }
    const key = section?.configKey ?? section?.heading ?? section?.originalHeading;
    if (!key) {
      return undefined;
    }
    const entry = sectionConfigMap[key];
    return entry ? entry.heading : undefined;
  };

  const renderPlainTextSection = (section, columnX, currentY, itemsForBlock, spacingAfterOverride) => {
    const processedSection = formatSectionForPlainText(section, {
      baseFontSize,
      compareFn: options.compareFn,
    });
    const sectionForText = { ...processedSection };
    const headingPreference = resolveHeadingPreference(section);
    const shouldShowHeading = headingPreference !== false;
    let resolvedHeading =
      sectionForText.heading ?? section.heading ?? section.originalHeading ?? section.templateEntry?.heading;
    if (headingPreference === true && !resolvedHeading) {
      resolvedHeading = section.originalHeading ?? section.templateEntry?.heading ?? section.heading;
    }
    if (!shouldShowHeading || !resolvedHeading) {
      delete sectionForText.heading;
    } else {
      sectionForText.heading = resolvedHeading;
    }
    const thisText = flattenStructuredResponse([sectionForText], [sectionForText]);
    const fontSize = processedSection.fontSize ?? baseFontSize;
    const fontStyle = processedSection.fontStyle ?? options.fontStyle;
    const textNode = new CustomText({
      x: columnX,
      y: padTop + currentY,
      width: textWidth,
      lineHeight: baseLineHeight,
      text: thisText,
      withMarkdown: true,
      fontFamily: processedSection.fontFamily ?? fontFamily,
      fill: options.fontFill,
      placeholderFill: options.placeholderFill,
      tableHeaderFill: options.tableHeaderFill,
      tableHeaderColor: options.tableHeaderColor,
      tableHeaderPlaceholderFill: options.tableHeaderPlaceholderFill,
      fontStyle,
      fontSize,
      refreshCallback: options.imageCallback,
    });
    group.add(textNode);
    itemsForBlock.push(textNode);
    const spacingAfterValue =
      spacingAfterOverride ?? computeSectionSpacing(processedSection);
    const height = textNode.height();
    return {
      heightConsumed: height,
      heightWithPaddingConsumed: height + spacingAfterValue,
      node: textNode,
    };
  };

  for (const block of workingText) {
    let yCursor = columnPositions[columnIndex];
    const itemsForBlock = [];
    if (maxContentHeight == null || yCursor < maxContentHeight) {
      for (const section of block ?? []) {
        const columnX = padLeft + columnIndex * (columnSpacing + textWidth);
        const sectionTopAbsolute = padTop + yCursor;
        const { renderer, node } = pickRenderer(section);
        const rendererName = renderer?.name;
        const spacingAfter = computeSectionSpacing(node ?? section);
        const clampHeight = (value) => {
          if (maxContentHeight == null) return value;
          const remaining = Math.max(maxContentHeight - yCursor, 0);
          return Math.min(value, remaining);
        };
        let consumedHeight = 0;
        let consumedHeightWithPadding = 0;
        let lastRenderedNode = null;

        if (renderer) {
          const sectionGroup = new Konva.Group({ name: 'structured_section' });
          group.add(sectionGroup);
          itemsForBlock.push(sectionGroup);
          const config = {
            ...baseRendererConfig,
            fontSize: node?.fontSize ?? baseRendererConfig.fontSize,
            fontStyle: node?.fontStyle ?? baseRendererConfig.fontStyle,
            itemCount:
              node?.itemCount !== undefined ? node.itemCount : baseRendererConfig.itemCount,
            includeIcons:
              node?.includeIcons !== undefined ? node.includeIcons : baseRendererConfig.includeIcons,
          };
          const ctx = {
            group: sectionGroup,
            config,
            availableWidth: textWidth,
            options,
            primitive: options.primitive,
            x: columnX,
            y: padTop + yCursor,
            spaceY: spacingAfter,
            clampHeight,
          };
          const nodeWithConfig = mergeConfigIntoNode(node, config);
          const res = renderer.render(ctx, nodeWithConfig) || {};
          const heightOnly = Number.isFinite(res.heightConsumed) ? res.heightConsumed : 0;
          const heightWithPadding =
            Number.isFinite(res.heightWithPaddingConsumed)
              ? res.heightWithPaddingConsumed
              : heightOnly + spacingAfter;
          consumedHeight = Math.max(0, heightOnly);
          consumedHeightWithPadding = Math.max(consumedHeight, heightWithPadding);
          lastRenderedNode = sectionGroup;
          lastRenderedNode.rendererName = rendererName;
        } else {
          const fallbackNode = mergeConfigIntoNode(section, baseRendererConfig);
          const fallback = renderPlainTextSection(
            fallbackNode,
            columnX,
            yCursor,
            itemsForBlock,
            spacingAfter
          );
          consumedHeight = Math.max(0, fallback.heightConsumed ?? 0);
          consumedHeightWithPadding = Math.max(
            consumedHeight,
            fallback.heightWithPaddingConsumed ?? consumedHeight + spacingAfter
          );
          lastRenderedNode = fallback.node;
        }

        const nextY = yCursor + consumedHeight;
        if (maxContentHeight != null && nextY > maxContentHeight) {
          didOverflow = true;
          const remainingHeight = Math.max(maxContentHeight - yCursor, 0);
          const clamped = clampOverflowedSection({
            rendererName: rendererName ?? lastRenderedNode?.rendererName,
            node: lastRenderedNode,
            availableHeight: remainingHeight,
            sectionStartY: sectionTopAbsolute,
            columnX,
            columnWidth: textWidth,
          });
          if (!clamped) {
            if (columnIndex === 0 && lastRenderedNode) {
              lastRenderedNode.destroy();
              itemsForBlock.pop();
            } else {
              itemsForBlock.forEach((nodeRef) => nodeRef.destroy());
            }
          } else {
            yCursor = maxContentHeight;
          }
          break;
        }

        yCursor += consumedHeightWithPadding;
      }
    }
    columnPositions[columnIndex] = yCursor + columnSpacing;
    columnIndex += 1;
    if (columnIndex === columns) {
      if (alignRows) {
        const maxInRow = Math.max(...columnPositions);
        columnPositions.fill(maxInRow);
      }
      columnIndex = 0;
    }
  }

  if (didOverflow) {
    group.attrs.overflowing = true;
  }

  return { didOverflow };
}

function extractStringList(section) {
  if (typeof section?.content === 'string') {
    return section.content.split(/\n/);
  }
  if (Array.isArray(section?.content)) {
    return section.content
      .map((item) => {
        if (typeof item === 'string') return item;
        if (item && typeof item === 'object' && typeof item.content === 'string') {
          return item.content;
        }
        return '';
      })
      .filter(Boolean);
  }
  if (Array.isArray(section?.subsections)) {
    return section.subsections
      .map((sub) => (typeof sub?.content === 'string' ? sub.content : ''))
      .filter(Boolean);
  }
  return [];
}

function ensureBulletPrefix(line) {
  const trimmed = line.trim();
  if (!trimmed) return '';
  return trimmed.startsWith('-') ? trimmed : `- ${trimmed}`;
}

function formatDetailLine(line) {
  let output = ensureBulletPrefix(line);
  output = output.replace(
    /^(\s*-\s*)([^:]+)(:?\s*.*)?$/u,
    (match, prefix, label, rest = '') => {
      let clean = label.trim();
      if (clean.startsWith('[')) clean = clean.slice(1);
      if (clean.endsWith(']')) clean = clean.slice(0, -1);
      if (!clean.startsWith('**')) clean = `**${clean}`;
      if (!clean.endsWith('**')) clean = `${clean}**`;
      return `${prefix}${clean}${rest}`;
    }
  );
  return output;
}

function transformDetailsBullets(section) {
  let items = extractStringList(section).map((line) => formatDetailLine(line)).filter(Boolean);
  if (!items.length) return section;
  if( section.itemCount !== undefined){
    items = items.slice(0, section.itemCount)
  }
  return {
    ...section,
    content: items.join('\n'),
    subsections: undefined,
  };
}

const QUOTE_FRAGMENT_REGEX = /\(?[Ff]ragments?:? ?(?:\d+(?:, ?\d+)*|\d+(?: and \d+)*|\d+)\)?/g;

function transformQuotes(section) {
  const lines = extractStringList(section)
    .map((line) => line.replace(QUOTE_FRAGMENT_REGEX, '').replace(/[ \t]{2,}/g, ' ').trim())
    .filter(Boolean)
    .map((line) => {
      const match = line.match(/^(\s*(?:[-*]|\d+\.)?\s*)(.*)$/);
      const text = match ? match[2] : line;
      const trimmed = text.trim();
      if (!trimmed) {
        return '';
      }
      const containsQuote = /["“”]/.test(trimmed);
      const normalized = containsQuote ? trimmed : `"${trimmed}"`;
      return wrapQuotedSectionsWithItalics(normalized.replaceAll('""', '"'));
    });
  if (!lines.length) return section;
  return {
    ...section,
    content: lines.join('\n'),
    subsections: undefined,
  };
}

function splitCompanies(value) {
  return value
    .split(/,|\n|\sand\s|\swith\s/gi)
    .map((entry) => entry.replace(/^\s*-\s+/, '').trim())
    .filter(Boolean);
}

function transformCompanyList(section) {
  let names = [];
  if (Array.isArray(section?.content)) {
    names = section.content
      .map((item) => (typeof item === 'string' ? item : item?.content))
      .filter(Boolean);
  } else if (typeof section?.content === 'string') {
    names = splitCompanies(section.content);
  }
  if (!names.length && Array.isArray(section?.subsections)) {
    names = section.subsections.map((sub) => sub?.content).filter(Boolean);
  }
  if (!names.length) return section;
  const formatted = names.map((name) => ensureBulletPrefix(name));
  return {
    ...section,
    content: formatted.join('\n'),
    subsections: undefined,
  };
}

function transformSentiment(section) {
  if (typeof section?.content !== 'string') {
    return section;
  }
  const normalized = section.content
    .replace(/_/g, ' ')
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  return {
    ...section,
    content: normalized,
  };
}

function wrapQuotedSectionsWithItalics(value = '') {
  if (typeof value !== 'string' || !value.trim()) {
    return value;
  }
  const wrapMatches = (input, pattern, formatter) =>
    input.replace(pattern, (match, inner, offset, original) => {
      const before = original[offset - 1];
      const after = original[offset + match.length];
      if (before === '_' && after === '_') {
        return match;
      }
      return formatter(inner);
    });
  let output = wrapMatches(value, /“([^”]+)”/g, (inner) => `_“${inner}”_`);
  output = wrapMatches(output, /"([^"]+)"/g, (inner) => `_"${inner}"_`);
  return output;
}

const BULLET_ICON_INDENT = 60;
const BULLET_ICON_SEARCH_WORD_LIMIT = 30;
const BULLET_ICON_SEARCH_MAX_PHRASE = 4;
const CLAMPABLE_RENDERERS = new Set(['summary', 'quotes', 'detailsBullets']);

function stripMarkdownForIconSearch(value = '') {
  return value
    .replace(/^[\s*-]+/, ' ')
    .replace(/\[(.*?)\]\((.*?)\)/g, '$1')
    .replace(/[*_`~]/g, ' ')
    .replace(/[“”]/g, '"')
    .replace(/[’]/g, "'")
    .replace(/[\u2013\u2014]/g, ' ')
    .replace(/[:;,]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function stripBulletMarkerForIcon(value = '') {
  return value.replace(/^\s*[-*•]+\s*/, '').trimStart();
}

function findPrimitiveMatchForBullet(line, resolvePrimitiveForHeaderFn) {
  if (typeof resolvePrimitiveForHeaderFn !== 'function') {
    return null;
  }
  const normalized = stripMarkdownForIconSearch(line);
  if (!normalized) {
    return null;
  }
  const words = normalized
    .split(/\s+/)
    .map((word) => word.replace(/^[^a-z0-9@&]+|[^a-z0-9@&]+$/gi, ''))
    .filter(Boolean)
    .slice(0, BULLET_ICON_SEARCH_WORD_LIMIT);
  if (!words.length) {
    return null;
  }
  for (let start = 0; start < words.length; start++) {
    const remaining = words.length - start;
    const maxSpan = Math.min(BULLET_ICON_SEARCH_MAX_PHRASE, remaining);
    for (let span = maxSpan; span >= 1; span--) {
      const phrase = words.slice(start, start + span).join(' ');
      if (!phrase) continue;
      const primitive = resolvePrimitiveForHeaderFn(phrase.replace(/'s$/,""))
      if (primitive) {
        return { primitive, phrase };
      }
    }
  }
  return null;
}

function createBulletIconPlaceholder({ x = 0, y = 0, size = 16, fill }) {
  const safeSize = Math.max(size, 12);
  return new Konva.Rect({
    x,
    y,
    width: safeSize,
    height: safeSize,
    cornerRadius: safeSize * 0.25,
    fill: fill ?? '#f1f5f9',
    stroke: '#d4d4d8',
    strokeWidth: 1,
    name: 'section section_details_icon_placeholder',
  });
}

function collectCustomTextNodes(node, acc = []) {
  if (!node) return acc;
  if (node instanceof CustomText) {
    acc.push(node);
    return acc;
  }
  if (typeof node.getChildren === 'function') {
    const children = node.getChildren();
    children.forEach((child) => collectCustomTextNodes(child, acc));
  }
  return acc;
}

function clampTextNodeWithinBounds(textNode, { availableHeight, sectionStartY }) {
  if (!textNode || typeof textNode.height !== 'function') {
    return false;
  }
  const nodeTop = typeof textNode.y === 'function' ? textNode.y() : 0;
  const relativeTop = nodeTop - sectionStartY;
  if (relativeTop >= availableHeight) {
    if (typeof textNode.visible === 'function') {
      textNode.visible(false);
      return true;
    }
    return false;
  }
  const currentHeight = textNode.height() ?? 0;
  if (!Number.isFinite(currentHeight)) {
    return false;
  }
  if (relativeTop + currentHeight <= availableHeight) {
    return false;
  }
  const newHeight = Math.max(availableHeight - relativeTop, 0);
  textNode.height(newHeight);
  if (typeof textNode.ellipsis === 'function') {
    textNode.ellipsis(true);
  }
  return true;
}

function clampOverflowedSection({
  rendererName,
  node,
  availableHeight,
  sectionStartY,
  columnX,
  columnWidth,
}) {
  if (!CLAMPABLE_RENDERERS.has(rendererName)) {
    //return false;
  }
  if (!node || !Number.isFinite(availableHeight) || availableHeight <= 0) {
    return false;
  }
  const textNodes = collectCustomTextNodes(node);
  if (!textNodes.length) {
    return false;
  }
  let modified = false;
  for (const textNode of textNodes) {
    if (clampTextNodeWithinBounds(textNode, { availableHeight, sectionStartY })) {
      modified = true;
    }
  }
  if (node instanceof Konva.Group) {
    node.clip({
      x: columnX,
      y: sectionStartY,
      width: columnWidth,
      height: availableHeight,
    });
    modified = true;
  }
  return modified;
}

const isHexColor = (value) => typeof value === 'string' && value.trim().startsWith('#');

const normalizePaddingValue = (value) => {
  if (value == null) {
    return null;
  }
  if (Array.isArray(value)) {
    const parts = value.map((entry) => (Number.isFinite(entry) ? entry : Number(entry) || 0));
    if (parts.length === 4) {
      return [...parts];
    }
    if (parts.length === 2) {
      return [parts[0], parts[1], parts[0], parts[1]];
    }
    if (parts.length === 1) {
      return [parts[0], parts[0], parts[0], parts[0]];
    }
    return null;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return [value, value, value, value];
  }
  if (typeof value === 'string') {
    const parts = value
      .split(',')
      .map((part) => parseFloat(part.trim()))
      .filter((part) => Number.isFinite(part));
    if (!parts.length) {
      return null;
    }
    if (parts.length === 4) {
      return parts;
    }
    if (parts.length === 2) {
      return [parts[0], parts[1], parts[0], parts[1]];
    }
    const single = parts[0];
    return [single, single, single, single];
  }
  return null;
};

const selectStyleVariant = (value, themeStyle) => {
  if (value == null) {
    return null;
  }
  if (Array.isArray(value) || typeof value === 'string' || typeof value === 'number') {
    return value;
  }
  if (themeStyle && typeof value === 'object' && !Array.isArray(value)) {
    if (Object.prototype.hasOwnProperty.call(value, themeStyle)) {
      return value[themeStyle];
    }
  }
  if (typeof value === 'object' && !Array.isArray(value)) {
    if (Object.prototype.hasOwnProperty.call(value, 'default')) {
      return value.default;
    }
    if (Object.prototype.hasOwnProperty.call(value, 'normal')) {
      return value.normal;
    }
  }
  return value;
};

const getStyleConfig = (options, themeStyle) => {
  if (!themeStyle) {
    return null;
  }
  const sources = [
    options.themeStyles,
    options.renderOptions?.themeStyles,
    options.renderConfig?.themeStyles,
  ];
  for (const source of sources) {
    if (source && source[themeStyle]) {
      return source[themeStyle];
    }
  }
  return null;
};

export function renderPlainObject(renderOptions = {}) {
  let {
    id,
    x = 0,
    y = 0,
    width = 128,
    height = 128,
    type,
    text,
    fontFamily,
    ...options
  } = {
    ...renderOptions,
  };
  let didOverflow = false;

  width = Math.abs(width);
  height = Math.abs(height);

  const theme = options.theme ?? defaultTheme;
  const isShapeElement = type === 'shape' || options.style === 'line' || options.style === 'shape';
  const elementName = type === 'image_gallery' ? 'image_element' : isShapeElement ? 'shape_element' : 'plain_object_element';
  const resolvedFontFamily = fontFamily ?? theme?.fontFamily ?? 'Arial';
  const themeStyle = options.themeStyle ?? options.renderOptions?.themeStyle ?? options.renderConfig?.themeStyle;
  const baseBackground = themeColor(theme, 'background', '#ffffff');
  const surfaceBackground = themeColor(theme, 'surface', baseBackground);
  const resolvedBackground = themeStyle ? themeColor(theme, themeStyle, surfaceBackground) : baseBackground;
  const themeStyleTextColor = themeStyle ? themeColor(theme, `${themeStyle}Text`, undefined) : undefined;
  const defaultFontColor = themeStyleTextColor ?? themeColor(theme, 'primary', '#000000');
  const textColorOverride = typeof options.text_color === 'string' ? options.text_color : undefined;
  const resolvedFontColor = textColorOverride
    ? (textColorOverride.startsWith('#')
        ? textColorOverride
        : themeColor(theme, textColorOverride, defaultFontColor))
    : defaultFontColor;
  const placeholderFill = mixHex(resolvedFontColor, resolvedBackground, 0.7);

  const resolvedTableHeaderBackground = themeColor(theme, 'header', '#999999');
  const resolvedTableFontColor = themeColor(theme, 'headerText', '#000000');
  const resolvedTablePlaceholderFill = mixHex(resolvedTableFontColor, resolvedTableHeaderBackground, 0.7);
  const styleConfig = getStyleConfig(options, themeStyle);
  const themePadding = normalizePaddingValue(selectStyleVariant(theme?.padding, themeStyle));
  const configuredPadding = normalizePaddingValue(selectStyleVariant(options.padding, themeStyle));
  const stylePadding = normalizePaddingValue(styleConfig?.padding);
  const basePadding = configuredPadding ?? stylePadding ?? themePadding;

  const heightForObjects = height //&& isFinite(height) ? height : undefined

  const resolvedGroupId = options.ids?.[0] ?? id;
  const group = new Konva.Group({
    id: resolvedGroupId,
    x,
    y,
    width,
    height: heightForObjects,
    hoverFill: theme?.palette?.hoverFill,
    hoverStroke: theme?.palette?.hoverStroke,
    name: `inf_track primitive ${elementName}`,
  });

  const userProvidedFill = Boolean(options.fill);
  const userProvidedStroke = Boolean(options.stroke);
  const fillKey = userProvidedFill ? options.fill : themeStyle;
  const strokeKey = userProvidedStroke ? options.stroke : themeStyle ? `${themeStyle}Border` : undefined;
  const defaultStrokeColor = themeColor(theme, 'border', '#e2e2e2');
  const strokeFallback =
    userProvidedFill && !userProvidedStroke
      ? defaultStrokeColor
      : !userProvidedStroke && themeStyle
        ? themeColor(theme, `${themeStyle}Border`, undefined)
        : undefined;
  const strokeColorFallback =
    strokeFallback ?? (userProvidedStroke || userProvidedFill ? defaultStrokeColor : undefined);
  const resolvePaletteOrHex = (value, fallback) => {
    if (!value) {
      return fallback;
    }
    if (isHexColor(value)) {
      return value;
    }
    return themeColor(theme, value, fallback);
  };

  if (fillKey || strokeKey) {
    if (options.style === 'line') {
      const line = new Konva.Line({
        points: [0, 0, width, height],
        stroke: resolvePaletteOrHex(strokeKey, strokeColorFallback),
      });
      group.add(line);
    } else {
      const rect = new Konva.Rect({
        x: 0,
        y: 0,
        width,
        height: heightForObjects,
        fill: resolvePaletteOrHex(fillKey, surfaceBackground),
        stroke: resolvePaletteOrHex(strokeKey, strokeColorFallback),
      });
      group.add(rect);
    }
  }

  if (options.style === 'text' || type === 'text') {
    let useText;
    if (options.compose) {
      const count = Array.isArray(text) ? text.length : 1;
      const flatText = Array.isArray(text) ? text.join('\n') : text;
      useText = options.compose.replaceAll('{text}', flatText);
      useText = useText.replaceAll('{count}', count);
    } else {
      useText = Array.isArray(text) ? text.join('\n') : text;
    }
    const textPaddingSource = selectStyleVariant(options.text_padding, themeStyle);
    const configuredTextPadding = normalizePaddingValue(textPaddingSource);
    const styleTextPadding = normalizePaddingValue(styleConfig?.text_padding ?? styleConfig?.textPadding);
    const padding = configuredTextPadding ?? styleTextPadding ?? basePadding ?? [0, 0, 0, 0];
    const [padTop, padRight, padBottom, padLeft] = padding;

    let fontStyle = options.fontStyle;

    if (options.fontStyle === 'auto') {
      fontStyle = 'normal';
      useText = useText
        .split('\n')
        .map((line) => {
          const match = line.match(/^([^:]+):/);
          if (match) {
            const prefix = match[1];
            return line.replace(prefix + ':', `**${prefix}**:`);
          }
          return line;
        })
        .join('\n');
    }
    let yOffset = 0;
    if (options.heading) {
      const heading = new CustomText({
        x: padLeft,
        y: padTop + yOffset,
        fontSize: 12,
        fontFamily: resolvedFontFamily,
        fontStyle: 'bold',
        text: options.heading.toUpperCase(),
        fill: themeColor(theme, 'muted', '#999999'),
        placeholderFill: mixHex(themeColor(theme, 'muted', '#999999'), resolvedBackground),
        showPlaceHolder: false,
        wrap: false,
        bgFill: 'transparent',
        align: 'center',
        width: width - padLeft - padRight,
        withMarkdown: false,
        ellipsis: false,
        refreshCallback: options.imageCallback,
      });
      group.add(heading);
      yOffset += heading.height() * 2;
    }

    const requestedColumns = Number(options.columns);
    const columns = Number.isFinite(requestedColumns) && requestedColumns > 0 ? Math.floor(requestedColumns) : 1;
    const finalColumns = Math.max(1, columns);
    const columnSpacingValue = Number(options.columnSpacing);
    const baseColumnSpacing = (options.fontSize ?? 16) * 0.5;
    const columnSpacing =
      Number.isFinite(columnSpacingValue) && columnSpacingValue >= 0 ? columnSpacingValue : baseColumnSpacing;
    const contentWidth = width - padLeft - padRight;
    const textWidth =
      finalColumns > 1 ? (contentWidth - columnSpacing * (finalColumns - 1)) / finalColumns : contentWidth;
    const availableTextHeight = heightForObjects ? heightForObjects - padTop - padBottom - yOffset : undefined;
    const lineHeight = options.lineHeight ?? 1.2;

    if (finalColumns > 1 && textWidth > 0) {
      const lines = String(useText ?? '').split('\n');
      const chunkSize = Math.max(1, Math.ceil(lines.length / finalColumns));
      for (let cIdx = 0; cIdx < finalColumns; cIdx += 1) {
        const from = cIdx * chunkSize;
        const to = from + chunkSize;
        const columnText = lines.slice(from, to).join('\n').trim();
        if (!columnText) {
          continue;
        }
        const columnNode = new CustomText({
          x: padLeft + cIdx * (textWidth + columnSpacing),
          y: padTop + yOffset,
          width: textWidth,
          height: availableTextHeight,
          lineHeight,
          text: columnText,
          withMarkdown: true,
          fill: resolvedFontColor,
          placeholderFill,
          fontFamily: resolvedFontFamily,
          fontSize: options.fontSize,
          align: options.align,
          fontStyle,
          refreshCallback: options.imageCallback,
        });
        if (availableTextHeight !== undefined && columnNode.height() > availableTextHeight + 0.1) {
          didOverflow = true;
        }
        group.add(columnNode);
      }
    } else {
      const textNode = new CustomText({
        x: padLeft,
        y: padTop + yOffset,
        width: contentWidth,
        height: availableTextHeight,
        lineHeight,
        text: useText,
        withMarkdown: true,
        fill: resolvedFontColor,
        placeholderFill,
        fontFamily: resolvedFontFamily,
        fontSize: options.fontSize,
        align: options.align,
        fontStyle,
        refreshCallback: options.imageCallback,
      });
      if (availableTextHeight !== undefined && textNode.height() > availableTextHeight + 0.1) {
        didOverflow = true;
      }
      group.add(textNode);
    }
    if (options.fromPrimitive) {
      group.name(`inf_track primitive ${elementName}`);
    }
  } else if (type === 'image_gallery') {
    const allImages = Array.isArray(options.images)
      ? options.images.filter((entry) => typeof entry?.url === 'string' && entry.url.trim().length > 0)
      : [];
    const skipSourceIds = new Set(
      [options.skipSourceIds]
        .flat()
        .map((value) => (value === undefined || value === null ? undefined : `${value}`.trim()))
        .filter(Boolean)
    );
    const visibleImages = allImages.filter((entry) => {
      const sourceId = entry?.primitiveId ? `${entry.primitiveId}` : undefined;
      if (!sourceId) {
        return true;
      }
      return !skipSourceIds.has(sourceId);
    });
    const rawStartIndex = Math.max(0, toInteger(options.startIndex ?? options.offset ?? 0, 0));
    const startIndex = visibleImages.length > 0
      ? Math.min(rawStartIndex, visibleImages.length - 1)
      : 0;
    const requestedCount = toInteger(options.count ?? options.limit ?? visibleImages.length, visibleImages.length);
    const count = Math.max(1, Number.isFinite(requestedCount) ? requestedCount : visibleImages.length);
    const primarySlice = visibleImages.slice(startIndex, startIndex + count);
    const fallbackPool = visibleImages.slice(startIndex + count);
    const usedUrls = new Set(primarySlice.map((entry) => entry?.url).filter(Boolean));
    let fallbackCursor = 0;
    const getFallback = () => {
      while (fallbackCursor < fallbackPool.length) {
        const next = fallbackPool[fallbackCursor];
        fallbackCursor += 1;
        const nextUrl = typeof next?.url === 'string' ? next.url : null;
        if (nextUrl && !usedUrls.has(nextUrl)) {
          usedUrls.add(nextUrl);
          return next;
        }
      }
      return null;
    };
    const galleryImages = primarySlice;
    const padding = basePadding ?? [0, 0, 0, 0];
    const [padTop, padRight, padBottom, padLeft] = padding;
    const availableWidth = Math.max(0, width - padLeft - padRight);
    const spacingValue = Number(options.imageSpacing);
    const spacing = Number.isFinite(spacingValue) ? Math.max(0, spacingValue) : 12;
    const columnValue = Number(options.columns);
    const defaultColumns = galleryImages.length <= 1 ? 1 : galleryImages.length === 2 ? 2 : 3;
    let columns = Number.isFinite(columnValue) && columnValue > 0 ? columnValue : defaultColumns;
    columns = Math.max(1, Math.min(columns, 6));
    const computedTileWidth =
      columns === 1 ? availableWidth : (availableWidth - spacing * (columns - 1)) / columns;
    const tileWidth = Math.max(
      32,
      Number.isFinite(computedTileWidth) ? computedTileWidth : availableWidth / Math.max(columns, 1) || width / Math.max(columns, 1) || 64
    );
    const aspectValue = Number(options.aspectRatio);
    const aspectRatio = Number.isFinite(aspectValue) && aspectValue > 0 ? aspectValue : 1;
    const rows = Math.max(1, Math.ceil(galleryImages.length / columns));
    const showCaptions = options.showCaptions !== undefined ? Boolean(options.showCaptions) : true;
    const minResolution = Number.isFinite(options.minResolution) ? Number(options.minResolution) : 512;
    const captionFontSize = options.captionFontSize ?? Math.max(10, (options.fontSize ?? 14) * 0.75);
    const captionHeight = showCaptions ? captionFontSize + 6 : 0;
    const displayHeight = Number.isFinite(heightForObjects) ? Math.max(0, heightForObjects - padTop - padBottom) : undefined;
    const availableImageHeight =
      displayHeight !== undefined
        ? Math.max(0, displayHeight - captionHeight * rows - spacing * (rows - 1))
        : undefined;
    let tileImageHeight =
      availableImageHeight !== undefined && availableImageHeight > 0
        ? availableImageHeight / rows
        : tileWidth / aspectRatio;
    if (!Number.isFinite(tileImageHeight) || tileImageHeight <= 0) {
      tileImageHeight = tileWidth / aspectRatio;
    }
    const tileHeight = tileImageHeight + captionHeight;
    let currentX = padLeft;
    let currentY = padTop;
    if (galleryImages.length === 0) {
      const placeholderText = options.emptyText ?? 'No images available';
      const placeholderNode = new CustomText({
        x: padLeft,
        y: padTop,
        width: availableWidth || width,
        height: heightForObjects ? heightForObjects - padTop - padBottom : undefined,
        align: 'center',
        text: placeholderText,
        fill: placeholderFill,
        withMarkdown: false,
        fontFamily: resolvedFontFamily,
        fontSize: options.fontSize ?? 14,
      });
      group.add(placeholderNode);
    } else {
      const imageHelperFn = options.imageHelper;
      for (let i = 0; i < galleryImages.length; i++) {
        const entry = galleryImages[i];
        if (!entry?.url) {
          continue;
        }
        if (i > 0 && i % columns === 0) {
          currentX = padLeft;
          currentY += tileHeight + spacing;
        }
        if (heightForObjects && currentY + tileHeight > heightForObjects - padBottom + 0.1) {
          didOverflow = true;
          break;
        }
        let imageNode;
        if (typeof imageHelperFn === 'function') {
          imageNode = imageHelperFn(entry.url, {
            x: currentX,
            y: currentY,
            width: tileWidth,
            height: tileImageHeight,
            center: true,
            fit: options.imageFit ?? 'cover',
            placeholder: options.placeholder !== false,
            imageCallback: options.imageCallback,
            name: 'image_gallery_item',
            minResolution,
            fallbackProvider: getFallback,
          });
        }
        if (!imageNode) {
          imageNode = new Konva.Rect({
            x: currentX,
            y: currentY,
            width: tileWidth,
            height: tileImageHeight,
            fill: themeColor(theme, 'overlay', '#e2e8f0'),
            stroke: themeColor(theme, 'border', '#cbd5f5'),
          });
        }
        group.add(imageNode);
        const captionText = typeof entry.label === 'string' ? entry.label.trim() : '';
        if (showCaptions && captionText) {
          const caption = new CustomText({
            x: currentX,
            y: currentY + tileImageHeight + 4,
            width: tileWidth,
            text: captionText,
            align: 'center',
            fontSize: captionFontSize,
            fontFamily: resolvedFontFamily,
            fill: themeColor(theme, 'muted', resolvedFontColor),
            ellipsis: true,
            withMarkdown: false,
            refreshCallback: options.imageCallback,
          });
          group.add(caption);
        }
        currentX += tileWidth + spacing;
      }
    }
  } else if (type === 'structured_text') {
    const { didOverflow: thisOverflow } = renderFormattedSections(text, group, {
      width,
      height: heightForObjects,
      fontFamily: resolvedFontFamily,
      fontFill: resolvedFontColor,
      placeholderFill,
      tableHeaderFill: resolvedTableHeaderBackground,
      tableHeaderColor: resolvedTableFontColor,
      tableHeaderPlaceholderFill: resolvedTablePlaceholderFill,
      ...options,
      padding: basePadding ?? [0, 0, 0, 0],
    });
    didOverflow ||= thisOverflow;
  }

  if (didOverflow) {
    group.attrs.overflowing = true;
  }

  return group;
}
